import React, { useEffect, useState } from "react";
import axios from "axios";
import { Mail, FileText, Star, Inbox } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/stats`, { withCredentials: true }).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { key: "total_contacts", label: "Kontaktanfragen", icon: Mail, link: "/admin/contacts" },
    { key: "unread_contacts", label: "Ungelesen", icon: Inbox, link: "/admin/contacts?status=unread", accent: true },
    { key: "total_posts", label: "Blog-Artikel", icon: FileText, link: "/admin/blog" },
    { key: "featured_posts", label: "Featured", icon: Star, link: "/admin/blog" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#1E3A8A]">Übersicht</div>
        <h1 className="mt-3 font-heading font-bold text-[#0A192F] text-3xl lg:text-4xl tracking-tight">Dashboard</h1>
        <p className="mt-2 text-slate-600">Schneller Überblick über Anfragen und Inhalte.</p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map(({ key, label, icon: Icon, link, accent }) => (
          <Link
            key={key}
            to={link}
            data-testid={`stat-card-${key}`}
            className={`group p-6 rounded-2xl border transition-all duration-300 ${
              accent ? "bg-[#0A192F] border-[#0A192F] text-white" : "bg-white border-slate-200 hover:shadow-lg hover:-translate-y-0.5"
            }`}
          >
            <div className="flex items-start justify-between">
              <div className={`w-11 h-11 rounded-full flex items-center justify-center ${accent ? "bg-white/10" : "bg-slate-100"}`}>
                <Icon size={20} className={accent ? "text-[#3B82F6]" : "text-[#0A192F]"} />
              </div>
            </div>
            <div className="mt-6 font-heading text-4xl font-bold tracking-tight">
              {stats ? stats[key] ?? 0 : "—"}
            </div>
            <div className={`mt-1 text-xs uppercase tracking-[0.2em] font-semibold ${accent ? "text-slate-300" : "text-slate-500"}`}>
              {label}
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-12 grid lg:grid-cols-2 gap-6">
        <Link to="/admin/contacts" className="block p-8 rounded-2xl bg-white border border-slate-200 hover:shadow-lg transition-all" data-testid="quick-contacts">
          <div className="font-heading text-xl font-semibold text-[#0A192F]">Neue Kontaktanfragen prüfen</div>
          <div className="mt-2 text-sm text-slate-600">Eingehende Nachrichten lesen, als gelesen markieren oder löschen.</div>
        </Link>
        <Link to="/admin/blog/new" className="block p-8 rounded-2xl bg-[#0A192F] text-white hover:bg-[#1E3A8A] transition-colors" data-testid="quick-new-post">
          <div className="font-heading text-xl font-semibold">Neuen Artikel verfassen</div>
          <div className="mt-2 text-sm text-slate-300">Insights, Case Studies und Whitepapers veröffentlichen.</div>
        </Link>
      </div>
    </div>
  );
}
